import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { ModulePermissionService } from './services/module-permission.service';
import { firstValueFrom } from 'rxjs';
import { MODULE_PERMISSION } from './constants';
import { ApiService } from './services/api.service';

export const budgetAccessGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const router: Router = inject(Router);
  const service: ModulePermissionService = inject(ModulePermissionService);
  const apiService: ApiService = inject(ApiService);
  const { budgetId } = route.params;

  const modulePermissionResponse: { hasPermission: boolean } = await firstValueFrom(service.hasViewerPermission(MODULE_PERMISSION.BUDGET));
  const purchaseRequestPermissionResponse: { hasPermission: boolean } = await firstValueFrom(apiService.hasBudgetAccessPermission(budgetId));

  if (modulePermissionResponse.hasPermission || purchaseRequestPermissionResponse.hasPermission) 
    return true;
  else 
    return router.createUrlTree(['/dashboard']);
};
